import { useState, useEffect } from "react";
import TodoForm from "../TodoForm/TodoForm";
import TodoList from "../TodoList/TodoList";
import styles from "../mainPage.module.css";
const TodoApp = ({ todos2, setTodos2 }) => {
  const addTodoHandler = (input, price, input2) => {
    const newTodo = {
      id: Math.floor(Math.random() * 1000),
      title: input,
      cost: price,
      description: input2,
    };
    setTodos2([...todos2, newTodo]);
  };

  const deleteHandler = (id) => {
    const filteredTodos = todos2.filter((todo) => todo.id !== id);
    setTodos2(filteredTodos);
  };

  return (
    <div className={styles.inputBox2}>
      <TodoForm addTodoHandler={addTodoHandler} />
      <TodoList todos2={todos2} deleteHandler={deleteHandler} />
    </div>
  );
};

export default TodoApp;
